import { CustomerService, IApplicationFilter, PortfolioReportCache, property, widget } from '@dynamik/common';
import { BindingEngine } from 'aurelia-framework';
import { WidgetBase } from '@dynamik/common';
import { customElement } from 'aurelia-templating';
import { formatISO } from 'date-fns/formatISO';
import { CustomerTotalValuesReportViewModel } from '@dynamik/common/clients/reporting-clients';

@customElement('nokkeltall-widget')
@widget('Nøkkeltall', true, true, 'Description')
export class NokkeltallWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, private portfolioReportCache: PortfolioReportCache, bindingEngine: BindingEngine) {
    super(element, bindingEngine, customerService);
  }

  nav: number;
  profitYTD: number;
  profitYTDPercent: number;
  profitPeriod: number;
  profitPeriodPercent: number;
  profitTotal: number;
  noGL: boolean;

  @property('Table')
  font?: string;

  @property('Table')
  fontSize?: number = 25;

  @property('Table')
  color?: string;

  @property('Data')
  historicalMonths?: number;

  @property()
  captionFont?: string;

  @property()
  captionFontSize?: number = 12;

  @property()
  captionColor?: string;

  override async loadData(filter: IApplicationFilter) {
    // fetch all data from 'beginning of times' to get total profit
    const fromDate = filter.dates.from;
    const fromDateStr = formatISO(fromDate, { representation: 'date' });
    return this.portfolioReportCache.customerTotals(filter.customer.companyId, fromDateStr, filter.dates.toStr, undefined, false, this.historicalMonths);
  }

  override async setData(data: CustomerTotalValuesReportViewModel[]) {
    const last = data[data.length - 1];
    this.noGL = !last?.netAssetValueClosingBalance;
    this.nav = last?.netAssetValueAdjusted ?? 0;
    this.profitTotal = last?.profitLossClosingBalance ?? 0;
    this.profitYTD = last?.profitLossChangeYearToDate ?? 0;
    this.profitYTDPercent = (last?.netAssetValueChangeYearToDateInPercent ?? 0) * 100;
    this.profitPeriod = last?.profitLossChangePeriod ?? 0;
    this.profitPeriodPercent = (last?.netAssetValueChangePeriodInPercent ?? 0) * 100;

    // Populate excelData for right-click export
    this.excelData = {
      fileName: 'Nøkkeltall',
      data: {
        Items: [
          {
            Metric: 'NAV (Net Asset Value)',
            Value: this.nav
          },
          {
            Metric: 'Profit YTD',
            Value: this.profitYTD
          },
          {
            Metric: 'Profit YTD %',
            Value: this.profitYTDPercent
          },
          {
            Metric: 'Profit Period',
            Value: this.profitPeriod
          },
          {
            Metric: 'Profit Period %',
            Value: this.profitPeriodPercent
          },
          {
            Metric: 'Total Profit/Loss',
            Value: this.profitTotal
          }
        ]
      }
    };
  }
}
